import type { DealerConfigSetting } from '../types/dealerConfig.types';

/** Fail-closed truth table shared by every boolean dealer-config resolver.
 *  A duplicated key is ambiguous, not "take the first" — no unique (dealer_id, key) index. */
export function readBooleanSetting(
    settings: DealerConfigSetting[] | null | undefined,
    key: string,
): boolean {
    if (!Array.isArray(settings)) {
        return false;
    }

    const rows = settings.filter((s) => s?.key === key);
    if (rows.length !== 1) {
        return false;
    }

    const value = rows[0].value;

    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value === 1;
    if (typeof value === 'string') return value === 'true' || value === '1';

    return false;
}
